import { MDSMenuItemProps } from "@/mds/components/menu/menu-item";
import { MDSMenuItemHeaderProps } from "@/mds/components/menu/menu-item-header/menu-item-header.types";

export enum MDSMenuContentItemKind {
  Item = "item",
  Header = "header",
  Divider = "divider",
}

export type MDSMenuContentItemItem = MDSMenuItemProps & { kind: MDSMenuContentItemKind.Item };
export type MDSMenuContentItemHeader = MDSMenuItemHeaderProps & {
  id: string;
  kind: MDSMenuContentItemKind.Header;
};
export type MDSMenuContentItemDivider = { id: string; kind: MDSMenuContentItemKind.Divider };

export type MDSMenuContentItem =
  | MDSMenuContentItemItem
  | MDSMenuContentItemHeader
  | MDSMenuContentItemDivider;

export type MDSMenuContentList = MDSMenuContentItem[];
